import { render, staticRenderFns } from "./ConfirmStudentDialog.vue?vue&type=template&id=1a3c6471&scoped=true"
import script from "./ConfirmStudentDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c6471",
  null
  
)

export default component.exports